import { COUNTRY_CODE_BY_NAME } from "./countrylist";
import { BANK_CODE_BY_NAME } from "./banklist";
import { ID_CODE_BY_NAME } from "./IdType";

const toFetchIDValue = (item, dataValue) => {


    let returnID = "";
    let itemObject = {};
     
    switch (String(item || "").toUpperCase()) {
        case "IDTYPE":
            itemObject = ID_CODE_BY_NAME;
            break;
        case "COUNTRIES":
            itemObject = COUNTRY_CODE_BY_NAME;
            break;
        case "BANKDATALIST":
            itemObject = BANK_CODE_BY_NAME;
            break;
        default:
            break;
    }

    Object.keys(itemObject).map(function (key) {
        if (dataValue === key) {
            returnID = itemObject[key];
        }
    });

    return returnID;
}

export default toFetchIDValue